<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">지출등록</span>
            <span class="txt">지출내역을 등록, 수정,관리할 수있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <span class="title">지출항목 설정</span>
                <div class="com-search-input">
                    <input placeholder="이름, 연락처 입력" type="text" />
                    <button class="search-btn">검색</button>
                </div>
            </div>
            <div class="line">
                <!-- <select-form :select-data='["사용여부","사용중","사용정지"]'></select-form> -->
                <select-form
                    :select-data="['지출구분', '고정', '변동']"
                    :select-value="['', 'F', 'C']"
                    :selected-value="getExpenseType"
                    @update:set="(val) => (getExpenseType = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <a class="com-btn blue" href="#" @click="itemPost">항목 등록</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 200px" />
                    <col style="width: 170px" />
                    <col style="width: 655px" />
                    <col style="width: 180px" />
                    <col style="width: 220px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>
                            <button>지출구분</button>
                        </th>
                        <th>
                            <button>지출항목</button>
                        </th>
                        <th>
                            <button>사용여부</button>
                        </th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>
                    <td>2019-12-25</td>
                    <td>고정</td>
                    <td>임대료</td>
                    <td>사용중</td>
                    <td>
                        <button class="com-btn blue" @click="modifyPop = true">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr> -->
                    <tr v-for="(s, index) in settingList" :key="s.index">
                        <td>{{ s.info.createdAt | timestampFilter }}</td>
                        <td>{{ convertType(s.expenseType) }}</td>
                        <td>{{ s.expenseItem }}</td>
                        <td>사용중</td>
                        <!--데이터 값 없음 -->
                        <td>
                            <button v-if="s.expenseType == 'C'" class="com-btn blue" @click="modifyVarPop(index)">
                                수정
                            </button>
                            <button v-if="s.expenseType == 'F'" class="com-btn blue" @click="modifyFixPop(index)">
                                수정
                            </button>
                            <button class="com-btn red" @click="onDeleteItems(s.templateId)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="settingList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 항목등록 팝업 -->
        <div v-show="editPop" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="editPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">항목등록</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 295px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    지출구분
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-1-1"
                                                v-model="expenseType"
                                                name="radio-pop-1"
                                                type="radio"
                                                value="C"
                                                @click="initPopup"
                                            />
                                            <label for="radio-pop-1-1">변동지출</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-1-2"
                                                v-model="expenseType"
                                                name="radio-pop-1"
                                                type="radio"
                                                value="F"
                                                @click="initPopup"
                                            />
                                            <label for="radio-pop-1-2">고정지출</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    항목명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="expenseItem" class="w400" type="text" />
                                </td>
                            </tr>
                            <tr v-show="expenseType == 'F'">
                                <th>
                                    금액
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input
                                        v-model="expensePrice"
                                        class="w400"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onKeyUpPrice"
                                    />
                                </td>
                            </tr>
                            <!--
                        <tr>
                            <th>사용여부 <span class="imp">*</span></th>
                            <td>
                                <div class="com-radio">
                                    <input type="radio" name="radio-pop-2" id="radio-pop-2-1" checked>
                                    <label for="radio-pop-2-1">사용중</label>
                                </div>
                                <div class="com-radio">
                                    <input type="radio" name="radio-pop-2" id="radio-pop-2-2">
                                    <label for="radio-pop-2-2">사용정지</label>
                                </div>
                            </td>
                        </tr>
                        --></tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="editPop = false">취소</button>
                        <button class="com-btn blue" @click="onPostItem">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 변동지출 수정 팝업 -->
        <div v-show="modifyPop" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="modifyPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">항목수정</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 295px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>지출구분</th>
                                <td>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-3-1"
                                            v-model="expenseType"
                                            checked
                                            name="radio-pop-3"
                                            type="radio"
                                            value="C"
                                        />
                                        <label for="radio-pop-3-1">변동지출</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>항목명</th>
                                <td>
                                    <input v-model="expenseItem" class="w400" type="text" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn red" @click="onDeleteItems">삭제</button>
                        <button class="com-btn" @click="modifyPop = false">취소</button>
                        <button class="com-btn blue" @click="editItem">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 고정지출 수정 팝업 -->
        <div v-show="modifyPop2" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="modifyPop2 = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">항목수정</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 295px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>지출구분</th>
                                <td>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-4-1"
                                            v-model="expenseType"
                                            checked
                                            name="radio-pop-4"
                                            type="radio"
                                            value="F"
                                        />
                                        <label for="radio-pop-4-1">고정지출</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>항목명</th>
                                <td>
                                    <input v-model="expenseItem" class="w400" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>금액</th>
                                <td>
                                    <input
                                        v-model="expensePrice"
                                        class="w400"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onKeyUpPrice"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn red" @click="onDeleteItems">삭제</button>
                        <button class="com-btn" @click="modifyPop2 = false">취소</button>
                        <button class="com-btn blue" @click="editItem">등록</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import EventBus from '../../../assets/js/eventBus';
import { timestampToDate } from '@/assets/js/excelCommon.js';
import { pagingInfo } from '@/assets/js/common';
import XLSX from 'xlsx';

export default {
    name: 'SalesExpenseSetting',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        getExpenseType(val) {
            console.log(val);
            this.getgetExpenseType = val;
            this.onSeachList();
        },
    },
    data() {
        return {
            // paymentType: 'Y', //항목등록 팝업 라디오 (고정지출: Y, 변동지출: N)
            editPop: false, // 항목등록 팝업
            modifyPop: false, // 변동지출 수정 팝업
            modifyPop2: false, // 고정지출 수정 팝업
            centerId: '',
            pagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            settingList: [],

            templateId: '', // 템플릿 Id
            expenseType: 'C', // 지출타입(C,F)
            expenseItem: '', // 지출내역
            expensePrice: '', // 지출가격
            getExpenseType: '',
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await this.onSeachList(); // 목록 가져오기
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.getSearchListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.forEach((s) => {
                const temp = {};
                temp['등록일'] = timestampToDate(s.info.createdAt);
                temp['지출구분'] = this.convertType(s.expenseType);
                temp['지출항목'] = s.expenseItem;
                temp['사용여부'] = '사용중'; // i.ccp_total_prod_cnt

                excelDownloadArray.push(temp);
            });
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [{ wch: 12 }, { wch: 12 }, { wch: 20 }, { wch: 15 }];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '지출등록항목');
            XLSX.writeFile(wb, '지출등록항목.xlsx');
        },
        // 엑셀 다운로드를 위한 리스트
        getSearchListExcel() {
            return api.get(`/admin/api/centerBill/expenseItemTemplate/${this.centerId}`, {
                params: {
                    expenseType: this.getExpenseType,
                },
            });
        },

        // 지출 목록 가져오기
        async onSeachList() {
            try {
                this.isLoading = true;
                const { data } = await this.getSearchList();
                console.log('지출목록 가져오기', data);
                // this.setPageParams(data);
                this.settingList = data;
                this.isLoading = false;
            } catch (error) {
                console.log('지출목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        getSearchList() {
            return api.get(`/admin/api/centerBill/expenseItemTemplate/${this.centerId}`, {
                params: {
                    expenseType: this.getExpenseType,
                },
            });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSeachList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSeachList();
        },
        // 수정
        async editItem() {
            try {
                const { data } = await this.modifyItem();
                alert('수정되었습니다.');
                this.modifyPop = false;
                this.modifyPop2 = false;
                this.onSeachList(); // 조회
            } catch (error) {
                console.log('error');
                console.log('수정 에러입니다.');
            }
        },
        // 센터 지출항목 템플릿수정
        modifyItem() {
            return api.put(`/admin/api/centerBill/expenseItemTemplate`, {
                centerId: this.centerId,
                templateId: this.templateId,
                expenseType: this.expenseType,
                expenseItem: this.expenseItem,
                expensePrice: this.getPureNumber(this.expensePrice),
            });
        },
        // 센터 지출항목 템플릿 삭제
        async onDeleteItems(templateId) {
            console.log(templateId);
            confirm('삭제하시겠습니까?');
            try {
                this.templateId = templateId;
                const { data } = await this.deleteItem();
                console.log('삭제되는 데이터값', data);
                alert('삭제되었습니다.');
                this.init();
            } catch (error) {
                console.log('삭제처리되지않았습니다.');
                console.log(error);
            }
        },

        // 삭제 API
        deleteItem() {
            return api.delete(`/admin/api/centerBill/expenseItemTemplate/${this.centerId}/${this.templateId}`);
        },

        // 등록 호출
        async onPostItem() {
            try {
                const validate = this.validateValues();
                console.log('e', validate);
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                const { data } = await this.getPostItem();
                alert('등록되었습니다.');
                this.editPop = false;
                this.init();
            } catch (error) {
                console.log(error);
                console.log('에러입니다.');
            }
        },

        // 등록 API
        getPostItem() {
            return api.post(`/admin/api/centerBill/expenseItemTemplate`, {
                centerId: this.centerId,
                templateId: this.templateId,
                expenseType: this.expenseType,
                expenseItem: this.expenseItem,
                expensePrice: this.getPureNumber(this.expensePrice),
            });
        },
        convertType(type) {
            if (type == 'C') {
                return '변동';
            } else if (type == 'F') {
                return '고정';
            }
        },
        // 변동수정팝업
        async modifyVarPop(index) {
            this.modifyPop = true;
            const { data } = await this.getSearchList();
            this.templateId = data[index].templateId;
            this.expenseType = data[index].expenseType;
            this.expenseItem = data[index].expenseItem;
        },
        // 고정수정팝업
        async modifyFixPop(index) {
            this.modifyPop2 = true;
            console.log('index값', index);
            const { data } = await this.getSearchList();
            console.log('고정수정팝업', data[index]);
            this.templateId = data[index].templateId;
            this.expenseType = data[index].expenseType;
            this.expenseItem = data[index].expenseItem;
            this.expensePrice = data[index].expensePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 등록 호출 popup
        itemPost() {
            this.editPop = true;
            this.expenseType = 'C'; // 지출형태 C 초기값
            this.expenseItem = ''; // 지출내역
            this.expensePrice = ''; // 지출가격
        },
        // 검색 조건 초기화
        resetSearchContent() {
            (this.getExpenseType = ''), (this.searchType = '');
            EventBus.$emit('event:initList', 'init');
        },
        // 파라미터 validate
        validateValues() {
            // 필수값 체크
            let result = false;
            const { expenseType, expenseItem, expensePrice } = this;
            let msg = '';

            // 지출구분
            if (expenseType === '' || expenseType === undefined) {
                msg = '지출구분을 선택하세요.';
                return { result, msg };
            }
            if (expenseType === 'F') {
                // 고정지출인경우
                if (expensePrice === '' || expensePrice === undefined) {
                    msg = '금액을 입력하세요.';
                    return { result, msg };
                }
            }
            if (expenseItem === '' || expenseItem === undefined) {
                msg = '항목을 입력하세요.';
                return { result, msg };
            }
            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트
            const num = this.getPureNumber(this.expensePrice);
            this.expensePrice = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            if (typeof num !== 'string' || num === undefined || num === '') {
                return num;
            }
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        initPopup() {
            // 라디오 버튼 클릭시 이전값 초기화
            this.expenseItem = '';
            this.expensePrice = '';
        },
    },
};
</script>
<style lang="scss"></style>
